const apiUrl = process.env.REACT_APP_API_URL;
export const PostJutgeProblemaIdTest = async (id_problema: string, json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes/${id_problema}/test`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(json)
            });
        if (!response.ok) {
            const text = await response.text();
            throw new Error(`Server returned ${response.status}: ${text}`);
        }
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error al guardar el test:', error);
        throw error; // Re-throw to handle in UI
    }
};
